export enum UserTypes {
	None = 'None',
	Opex = 'Opex',
	Erm = 'Erm',
	Client = 'Client',
}
